import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "PageOverview" }
const _hoisted_2 = { id: "TableImports" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "WideCell" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "NarrowCell" }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "NarrowCell" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Status overview of imports", -1 /* HOISTED */)),
    (_ctx.storedImports.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("tbody", null, [
              _cache[3] || (_cache[3] = _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "WideCell" }, " ID "),
                _createElementVNode("th", { class: "NarrowCell" }, " Name "),
                _createElementVNode("th", null, " Timestamp start "),
                _createElementVNode("th", { class: "NarrowCell" }, " Timestamp end "),
                _createElementVNode("th", null, " Initiated by "),
                _createElementVNode("th", null, " Status ")
              ], -1 /* HOISTED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedImports, (storedImport, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: storedImport.id
                }, [
                  (_ctx.shouldEntryBeShown(index))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, [
                          _createElementVNode("span", {
                            title: storedImport.id
                          }, _toDisplayString(storedImport.id), 9 /* TEXT, PROPS */, _hoisted_5)
                        ]),
                        _createElementVNode("td", _hoisted_6, [
                          _createElementVNode("span", {
                            title: storedImport.title ? storedImport.title : 'Not available'
                          }, _toDisplayString(storedImport.title ? storedImport.title : 'Not available'), 9 /* TEXT, PROPS */, _hoisted_7)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            title: _ctx.convertTimestampToDateString(storedImport.timestampStart)
                          }, _toDisplayString(_ctx.convertTimestampToDateString(storedImport.timestampStart)), 9 /* TEXT, PROPS */, _hoisted_8)
                        ]),
                        _createElementVNode("td", _hoisted_9, [
                          _createElementVNode("span", {
                            title: storedImport.timestampEnd ? _ctx.convertTimestampToDateString(storedImport.timestampEnd) : 'Not available'
                          }, _toDisplayString(storedImport.timestampEnd ? _ctx.convertTimestampToDateString(storedImport.timestampEnd) : 'Not available'), 9 /* TEXT, PROPS */, _hoisted_10)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            title: storedImport.initiator
                          }, _toDisplayString(storedImport.initiator), 9 /* TEXT, PROPS */, _hoisted_11)
                        ]),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.getLabelOfStatus(storedImport.status)) + " ", 1 /* TEXT */),
                          (_ctx.shouldRefreshButtonBeShown(storedImport))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.updateStatus(storedImport))
                              }, _cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "OverviewActionIcon lnr-redo2" }, null, -1 /* HOISTED */)
                              ]), 8 /* PROPS */, _hoisted_12))
                            : (_ctx.shouldErrorDetailsButtonBeShown(storedImport))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.showErrorDetails(storedImport.id))
                                }, _cache[2] || (_cache[2] = [
                                  _createElementVNode("i", { class: "OverviewActionIcon lnr-document" }, null, -1 /* HOISTED */)
                                ]), 8 /* PROPS */, _hoisted_13))
                              : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          (_ctx.doesAmountOfImportsExceedLimit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.increaseLimit && _ctx.increaseLimit(...args)))
              }, " Load more "))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, " No imports found. "))
  ]))
}